
import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';

import { serverRequest } from "../../../util/server_request";
import { extractErrorMessage } from '../../extractErrorMessage';
import { notifyUser } from '../../../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

// Fetches all corporate accounts from /all-corporate-accounts endpoint using React Query
export function useAllLife() {
  return useQuery({
    queryKey: ['all-life'],
    queryFn: async () => {
      try {
        const result = await serverRequest('GET', 'policies');
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch all life policies');
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch all life policies');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
